<template>
  <div class="page__category category">
    <div class="category__container container container--xl">
      <transition-group :css="false" @enter="beverageEnter" name="beverages"
        tag="div" class="category__beverages">
        <div class="category__beverage thumb" :data-index="index" v-for="(beverage, b, index) in filteredBeverages"
          :key="'beverage'+b" :style="{backgroundColor:beverage.color}">
           <router-link :to="beverage.path">
                         <img v-if="beverage.sizes[0].alt_title" :src="mediaPath(beverage.sizes[0]['size_image_'+$store.getters.lang])" class="thumb__image" :alt="beverage.sizes[0].alt_title" :title="$store.getters.page.title + ' ' + index" />
          <img v-else class="thumb__image" :src="mediaPath(beverage.sizes[0]['size_image_'+$store.getters.lang])" :alt="$store.getters.pages._.meta_title + ' ' + b" :title="$store.getters.pages._.meta_title + ' ' + b" />
          </router-link>
            <div class="thumb__title">
              <router-link :to="beverage.path">
                {{beverage.title}}
              </router-link>
              {{beverage.type}}
            </div>
         <router-link :to="beverage.path" class="link" style="relative"><span>{{$store.state.ui.read_more_label}} <i class="more__arrow more__category"></i></span></router-link>
        </div>
      </transition-group>
      <div class="category__no-results" v-if="!hasBeverages">
        <h1 v-text="ui.no_results" />
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
import latinize from 'latinize'

import { mapGetters } from 'vuex'
import page from '@/mixins/page'

export default {
  mixins: [page],
  beforeMount() {
    if (this.allBeverages.length) {
      this.initSearch(this.allBeverages)
    }
  },
  computed: {
    ...mapGetters(['ui', 'lang', 'allBeverages']),
    searchQuery() {
      return this.$route.params['q']
    }
  },
  data() {
    return {
      beverages: {},
      filteredBeverages: {},
      hasBeverages: true
    }
  },
  methods: {
    getDefaultImage(beverage) {
      var o = {}
      if (beverage.sizes) {
        beverage.sizes.forEach((b, i) => {
          if (Number(b.show_default) === 1) {
            o = this.bg(b['size_image_' + this.lang])
          }
        })
      }
      return o
    },
    beverageEnter(el, done) {
      anime({
        targets: el,
        opacity: [0, 1],
        translateY: ['3rem', 0],
        duration: 350,
        easing: 'easeOutQuad',
        elasticity: 0,
        delay: Number(el.dataset.index * 150),
        complete: () => {
          done()
        }
      })
    },
    initSearch(b) {
      this.filteredBeverages = this.allBeverages.filter(item => {
        return latinize(item['search'])
          .toLowerCase()
          .includes(latinize(this.$route.params.q).toLowerCase())
      })
    }
  },
  mounted() {},
  name: 'SearchResultsTemplate',
  watch: {
    filteredBeverages(newVal, oldVal) {
      setTimeout(() => {
        this.hasBeverages = Object.keys(newVal).length
      }, 3)
    },
    allBeverages(b) {
      this.initSearch(b)
    },
    searchQuery(q) {
      this.filteredBeverages = this.allBeverages.filter(item => {
        return latinize(item['search'])
          .toLowerCase()
          .includes(latinize(q).toLowerCase())
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/templates/SearchResultsTemplate.vue